import { HmacSHA1, Base64 } from "crypto-js";

export default {
  init() {


    function CalculateSig(stringToSign, privateKey){
        //calculate the signature needed for authentication
        var hash = HmacSHA1(stringToSign, privateKey);
        var base64 = hash.toString(Base64);
        return encodeURIComponent(base64);
    }

    //set variables
    var d = new Date;
    var expiration = 3600; // 1 hour,
    var unixtime = parseInt(d.getTime() / 1000);
    var future_unixtime = unixtime + expiration;
    var publicKey = "a7528d2010";
    var privateKey = "c00397a1708e677";
    var method = "POST";
    var route = "forms/1/submissions";
    var stringToSign = publicKey + ":" + method + ":" + route + ":" + future_unixtime;
    var sig = CalculateSig(stringToSign, privateKey);
    var url = 'https://kojo.co/gravityformsapi/' + route + '?api_key=' + publicKey + '&signature=' + sig + '&expires=' + future_unixtime;

    $('#contact_method').on('change', (e) => {
      if( $(e.currentTarget).val() == 'phone') {
        $('#contact').attr('placeholder','Phone Number');
        $('#contact').clone().attr('type','tel').insertAfter('#contact').prev().remove();
      } else {
        $('#contact').attr('placeholder','yourname@company.com');
        $('#contact').clone().attr('type','email').insertAfter('#contact').prev().remove();
      }
    }).trigger('change');

    $('[name="say_hello_form"]').on('submit', function(e) {
      e.preventDefault();

      // input ID's on form (within GF editor)
      var values = {input_values : {
        input_1 : $('#subject').val(),
        input_2 : $('#message').val(),
        input_5 : $('#contact_method').val(),
        input_4 : $('#contact').val(),
        input_6 : $('#name').val(),
      },
    };

    var values_json = JSON.stringify(values);

    $('.contact-form__submitting').addClass('contact-form__submitting--submitting');
        $.post(url, values_json, function() {
        })
        .done(function() {
          // redirect user to thank you page
          var url = window.location.href;
          url += url.substr(-1) == "/" ? "" : "/"
          window.location = url + 'thank-you#success';
        })
        .fail(function() {
          $('#response').html('Sorry, <br>An error occured, and your form was not submitted.');
          $('.contact-form__text').slideUp();
        });
      });

      return false;
      //json encode array
  },
}



// WEBPACK FOOTER //
// ./scripts/gravity-forms.js